export default "__VITE_ASSET__045w_zfh__"